import React from 'react';

const CouponsContext = React.createContext()

// export const CouponsProvider = CouponsContext.Provider
// export const CouponsConsumer = CouponsContext.Consumer

export default CouponsContext